import { render, staticRenderFns } from "./CarSale.vue?vue&type=template&id=72e242b7"
import script from "./CarSale.vue?vue&type=script&lang=js"
export * from "./CarSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports